/**
 * Typed wrapper for the G11 engagement upcoming-events feed.
 *
 *   GET /api/v1/engagement/upcoming?window_days=N
 *
 * Any authenticated tenant user reaches this endpoint — it returns
 * birthdays + work-anniversaries inside the requested window for the
 * caller's tenant (server-scoped, no client-supplied tenant_id). Used by
 * the dashboard's "This fortnight" widget.
 */

import { api } from "./client";

export const ENGAGEMENT_BASE = "/api/v1/engagement";

export type UpcomingKind = "birthday" | "anniversary";

export interface UpcomingItem {
  employee_id: number;
  /** The server sends the name split (handlers/engagement.go) — render via
   *  lib/engagement-format upcomingDisplayName, never a `name` field. */
  first_name: string;
  last_name: string;
  kind: UpcomingKind;
  /** YYYY-MM-DD — the actual date the event falls on this calendar year. */
  date_in_window: string;
  /** Service years on the upcoming anniversary; omitted on birthdays. */
  years_for_anniversary?: number;
}

export interface UpcomingResponse {
  generated_at: string;
  items: UpcomingItem[];
  window_days: number;
}

export async function getUpcoming(
  windowDays = 14,
  signal?: AbortSignal,
): Promise<UpcomingResponse> {
  const { data } = await api.get<UpcomingResponse>(
    `${ENGAGEMENT_BASE}/upcoming`,
    {
      params: { window_days: String(windowDays) },
      signal,
    },
  );
  return data;
}
